:host {
  font-weight: 500;
  text-transform: uppercase;
  display: contents;
}
